import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import dateFormat from 'dateformat';
import axios from 'axios';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
// import Mood from '@material-ui/icons/Mood';
// import Mood from '@material-ui/icons/InsertCommentTwoTone';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Divider, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { triggerUseEffect } from '../../services/store/actions';

import { CommonConfig } from '../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '16px',
        paddingTop: '15px',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
        '& label': {
            fontSize: '18px !important',
            fontWeight: '500',
        },
        '& textarea': {
            borderBottom: '1px solid #ccc',
        },
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    formControlCall: {
        // margin: theme.spacing(2),
        minWidth: 370,
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    remarkDiv: {
        maxHeight: '100px',
        overflowY: 'scroll',
        background: '#e8e7e7',
        paddingLeft: '10px',
        // border: '1px solid #d3d3d3',
        borderRadius: '5px',
        wordBreak: 'break-word',
    },
}));
export default function FormDialog({ row, axiosConfig, tennantName }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [enterRemark, setenterRemark] = React.useState();
    const [allRemarks, setallRemarks] = React.useState(row.remarks);
    const dispatch = useDispatch({});

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const remarkValue = (e) => {
        setenterRemark(e.target.value);
    };
    const save = () => {
        if (typeof enterRemark !== 'undefined' && enterRemark != null && enterRemark.length) {
            const remObj = {
                serviceId: row.serviceId,
                longOpenRemark: enterRemark,
            };

            let apiUrl = `${CommonConfig.dev.baseUrl}/api/auth/remark-added/${tennantName}`;

            axios
                .post(apiUrl, remObj, axiosConfig)
                .then((response) => {
                    dispatch(triggerUseEffect(enterRemark));
                    setenterRemark('');
                })
                .catch((error) => {
                    ////console.log(error);
                });
        }
    };
    useEffect(() => {
        setallRemarks(row.remarks);
    }, [row]);

    return (
        <>
            <Tooltip title="Add Remarks" onClick={handleClickOpen}>
                <IconButton aria-label="Add Remarks">
                    <AssignmentIcon />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
                // disableBackdropClick
            >
                <DialogTitle className={classes.formControlCall} id="alert-dialog-title">
                    Add Remarks
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        <InputLabel className="lbl" htmlFor="remarks" shrink>
                            {' '}
                            Enter Remark
                        </InputLabel>
                        <TextField
                            // autoFocus
                            // margin="dense"
                            // multiline
                            // rowsMax={4}
                            // id="Remark"
                            // placeholder="Enter your remarks"
                            InputProps={{
                                classes: { root: classes.bottomLine },
                            }}
                            // type="text"
                            // onChange={(e) => remarkValue(e)}
                            // value={enterRemark}
                            // fullWidth
                            autoFocus
                            margin="dense"
                            // label="Enter Remark"
                            multiline
                            rowsMax={4}
                            id="Remark"
                            // label="Enter Remark"
                            type="text"
                            onChange={(e) => remarkValue(e)}
                            value={enterRemark}
                            fullWidth
                            className="txtUnderline"
                        />
                        <div className={classes.remarkDiv}>
                            {allRemarks &&
                                [...allRemarks].reverse().map((row, index) => (
                                    <>
                                        {row.remarkStated} <br /> by {row.userEmail} <br /> on{' '}
                                        {dateFormat(row.timeStamp, 'dddd, mmmm dS, yyyy')}
                                        <br />
                                        <Divider style={{ color: '#000' }} />
                                    </>
                                ))}
                        </div>
                    </DialogContentText>
                    {/* {////console.log('---', row)} */}
                    {/* <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="relevence-remarks" shrink className={classes.inLabel}>
                                Add Remarks
                            </InputLabel>
                            <TextField
                                id="relevence-remarks"
                                multiline
                                rows={5}
                                placeholder="Enter Your Remarks"
                                InputProps={{
                                    classes: { root: classes.bottomLine },
                                }}
                                style={{ paddingTop: '15px' }}
                                value={remarks}
                                onChange={(event) => setRemarks(event.target.value)}
                            />
                        </FormControl> */}
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => handleClose()} variant="outlined" className={classes.button}>
                        Close
                    </Button>
                    <Button onClick={() => save()} variant="outlined" className={classes.button} autoFocus>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
